"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPaymentMethodContext = void 0;
const React = require("react");
/**
 * Provides the customer's payment method
 */
exports.CustomerPaymentMethodContext = React.createContext({
    paymentMethod: undefined,
    setPaymentMethod: undefined,
    isLoading: undefined,
    errors: undefined,
    fetchPaymentMethod: undefined,
    updatePaymentMethod: undefined,
    deletePaymentMethod: undefined
});
//# sourceMappingURL=index.js.map